// see more details about the experimental here https://housinganywhere.atlassian.net/browse/HA-3091
export const experimentalCountry = ['spain', 'es'];
export const experimentalCities = ['barcelona', 'madrid'];

export function checkIfCityInSeoExperiment(
  city: string | undefined,
  country: string | undefined,
): boolean {
  return Boolean(
    city &&
      experimentalCities.includes(city.toLowerCase()) &&
      country &&
      experimentalCountry.includes(country.toLowerCase()),
  );
}
